export const easing = ({
  elapsedTime,
  initialScrollTop,
  change,
  duration
}: {
  elapsedTime: number;
  initialScrollTop: number;
  change: number;
  duration: number;
}) => {
  if ((elapsedTime /= duration / 2) < 1) {
    return (change / 2) * elapsedTime * elapsedTime + initialScrollTop;
  }

  return (-change / 2) * (--elapsedTime * (elapsedTime - 2) - 1) + initialScrollTop;
};

export const isMouseOverScrollbar = (element: HTMLElement, event: MouseEvent) => {
  const rect = element.getBoundingClientRect();
  const scrollbarWidth = element.offsetWidth - element.clientWidth;
  const isOverScrollbar = event.clientX > rect.right - scrollbarWidth;
  return isOverScrollbar;
};

type WindowEventListener<K extends keyof WindowEventMap> = (this: Window, ev: WindowEventMap[K]) => unknown;
type HTMLElementEventListener<K extends keyof HTMLElementEventMap> = (this: HTMLElement, ev: HTMLElementEventMap[K]) => unknown;

export function addEventListener<K extends keyof WindowEventMap>(
  target: Window,
  eventName: K,
  listener: WindowEventListener<K>,
  options?: boolean | AddEventListenerOptions
): () => void;
export function addEventListener<K extends keyof HTMLElementEventMap>(
  target: HTMLElement,
  eventName: K,
  listener: HTMLElementEventListener<K>,
  options?: boolean | AddEventListenerOptions
): () => void;
export function addEventListener<K extends string>(
  target: Window | HTMLElement,
  eventName: K,
  listener: (...args: unknown[]) => unknown,
  options?: boolean | AddEventListenerOptions
): () => void {
  target.addEventListener(eventName, listener, options);
  return () => target.removeEventListener(eventName, listener, options);
}

export const isAutoScrollButtonOverlappingWithReader = () => {
  // We only check the overlap for PDFs/book reader because regardless of dark mode or not the page is always white.
  const tooltip = document.querySelector('[role="tooltip"]');
  const reader = document.querySelector('.PSPDFKit-Container')?.shadowRoot?.querySelector('#speechify-highlight-container');
  if (!tooltip || !reader) return false;

  const tooltipBoundingBox = tooltip?.getBoundingClientRect();
  const readerBoundingBox = reader.getBoundingClientRect();

  return !(
    tooltipBoundingBox.right < readerBoundingBox.left ||
    tooltipBoundingBox.left > readerBoundingBox.right ||
    tooltipBoundingBox.bottom < readerBoundingBox.top ||
    tooltipBoundingBox.top > readerBoundingBox.bottom
  );
};
